<template lang="html">
  <div class="pay-fail">
    <div class="conetent">
      <div class="information">
        <div class="info">
          <h2 class="title">订单支付支付失败</h2>
          <h4 class="txt">网络系统异常，请稍后付款！</h4>
        </div>
        <i class="icon"></i>
      </div>
      <div class="link">
        未完成支付的订单，可进入社区，
        <a class="per" href="https://forum.bitahub.com">查看订单详情</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
  .pay-fail
    width 100%
    .conetent
      width 1000px
      min-height 500px
      margin 20px auto
      padding 20px 50px
      padding 80px 10px 20px 100px
      background: #fff
      .information
        font-size 0
        .info
          display inline-block
          width 330px
          .title
            height 34px
            line-height 24px
            font-size 18px
            color #e26272
          .txt
            font-size 14px
            color #8f9498
            line-height 28px
        .icon
          display inline-block
          width 112px
          height 66px
          background url(../../common/image/icon/icon-fail.png) no-repeat 50%
          background-size 112px 66px
      .link
        width 100%
        padding-top 60px
        line-height 28px
        color #666
        font-size 14px
        .per
          color #4da1ff
</style>
